import type {} from "@mui/x-data-grid/themeAugmentation";

import { createTheme } from "@mui/material/styles";

import defaultTheme from "./default";

import variables from "../scss/_variables.scss";

const theme = createTheme(defaultTheme, {
    typography: {
        fontSize: 15,
    },
    components: {
        MuiLink: {
            styleOverrides: {
                root: {
                    textDecoration: "none",
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundColor: "#000",
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    ":disabled": {
                        color: "rgba(255, 255, 255, 0.26)",
                        backgroundColor: "rgba(255, 255, 255, 0.12)",
                    },
                },
            },
        },
        MuiToolbar: {
            styleOverrides: {
                root: {
                    color: "#fff86e",
                },
            },
        },
        MuiAlert: {
            styleOverrides: {
                action: {
                    color: variables.warningColor,
                },
                message: {
                    color: variables.warningColor,
                },
            },
        },
    },
    palette: {
        background: {
            default: "#000",
        },
        text: {
            primary: "#fff86e",
        },
        primary: {
            main: "#fff86e",
            contrastText: "#000",
        },
        secondary: {
            main: "#000",
            contrastText: "#fff86e",
        },
    },
    customComponents: {
        infoBox: {
            backgroundColor: "#0c1a09",
            accentColor: "#98c548",
        },
    },
});

export default theme;
